var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "spaceCenter common common-form-inline" },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          staticStyle: { width: "400px" },
          attrs: {
            model: _vm.pageData,
            rules: _vm.rules,
            "label-col": _vm.labelCol,
            "wrapper-col": _vm.wrapperCol
          }
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "用户名", prop: "loginName" } },
            [
              _c("a-input", {
                attrs: { disabled: !_vm.noInit },
                model: {
                  value: _vm.pageData.loginName,
                  callback: function($$v) {
                    _vm.$set(_vm.pageData, "loginName", $$v)
                  },
                  expression: "pageData.loginName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-model-item",
            { attrs: { label: "手机号码/电子邮箱", prop: "mobileOrEmail" } },
            [
              _c("a-input", {
                model: {
                  value: _vm.pageData.mobileOrEmail,
                  callback: function($$v) {
                    _vm.$set(_vm.pageData, "mobileOrEmail", $$v)
                  },
                  expression: "pageData.mobileOrEmail"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-model-item",
            { attrs: { label: "验证码", prop: "captchaCode" } },
            [
              _c(
                "div",
                { staticClass: "input-box" },
                [
                  _c("a-input", {
                    model: {
                      value: _vm.pageData.captchaCode,
                      callback: function($$v) {
                        _vm.$set(_vm.pageData, "captchaCode", $$v)
                      },
                      expression: "pageData.captchaCode"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "input-btn",
                      attrs: {
                        type: "primary",
                        disabled: _vm.codeAble || _vm.countDisabled,
                        size: "small"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onFetchCode()
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.counter > 0,
                              expression: "counter>0"
                            }
                          ]
                        },
                        [_vm._v(_vm._s(_vm.counter))]
                      ),
                      _vm._v(
                        _vm._s(
                          _vm.countDisabled ? "s重新获取" : "免费获取验证码"
                        ) + "\n                "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-size-12 text-color-red",
                  staticStyle: { position: "absolute", "white-space": "nowrap" }
                },
                [_vm._v(_vm._s(_vm.errMsg))]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17451f98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17451f98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/user-modify.vue
// module id = pdcX
// module chunks = 1